import { supabase } from './supabase';

const DEFAULT_CATEGORIES = [
  { name: '거주지', emoji: '🏠' },
  { name: '자동차', emoji: '🚗' },
  { name: '핸드폰', emoji: '📱' },
  { name: '시계',   emoji: '⌚' },
  { name: '학교',   emoji: '🏫' },
  { name: '직장',   emoji: '💼' },
  { name: '여행',   emoji: '✈️' },
  { name: '물건',   emoji: '📦' },
  { name: '사건',   emoji: '⭐' },
];

// 동시 실행 방지
let initPromise = null;

export async function initDefaultCategories(userId) {
  if (initPromise) return initPromise;

  initPromise = (async () => {
    try {
      const { data } = await supabase
        .from('categories')
        .select('id')
        .eq('user_id', userId)
        .limit(1);

      if (data && data.length > 0) return;

      await supabase.from('categories').insert(
        DEFAULT_CATEGORIES.map(({ name, emoji }, i) => ({ name, icon: emoji, user_id: userId, sort_order: i }))
      );
    } finally {
      initPromise = null;
    }
  })();

  return initPromise;
}
